export default "__VITE_ASSET__CcYyq62N__"